import { render } from "./Permission.vue?vue&type=template&id=b75d3512&scoped=true&ts=true"
import script from "./Permission.vue?vue&type=script&lang=ts"
export * from "./Permission.vue?vue&type=script&lang=ts"

import "./Permission.vue?vue&type=style&index=0&id=b75d3512&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b75d3512"]])

export default __exports__